import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"app/fonts.ts\",\"import\":\"Exo_2\",\"arguments\":[{\"subsets\":[\"cyrillic-ext\",\"latin\",\"latin-ext\"],\"weight\":[\"400\",\"700\",\"800\"],\"style\":\"normal\",\"display\":\"swap\",\"variable\":\"--font-exo2\"}],\"variableName\":\"exo2\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/app/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/part-footer/part-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/part-header/part-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/build/repo/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/global.scss");
